var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "SI_4L_fill_red",
    r: 19,
    cx: 21,
    cy: 21
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_fill_red_compl",
    d: "M30.53 26.99c.4.39.4 1.02.01 1.42h-.01l-2.12 2.12a.996.996 0 01-1.41 0l-6-6-6 6a.996.996 0 01-1.41 0l-2.12-2.13a.996.996 0 010-1.41l6-6-6-6a.996.996 0 010-1.41l2.12-2.12a.996.996 0 011.41 0l6 6 6-6a.996.996 0 011.41 0l2.12 2.12c.39.39.39 1.02 0 1.41l-6 6.01 5.99 5.99z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.80fe551f631df30b71d2414b7d478d17.svg";
export { ForwardRef as ReactComponent };